import React from 'react';
import { Tooltip } from 'antd';
import PermissionGate from '../../auth/PermissionGate';

// Journeys' PermissionGate: wraps a SINGLE control. Users holding `permission` see the
// control untouched; others see it inert (disabled / onClick removed / greyed) with a
// tooltip, so the control stays visible. `grep JourneyPermissionGate` lists every gated
// journey control.
export default function JourneyPermissionGate({ permission, children, tip = 'Advanced editing access required' }) {
  return (
    <PermissionGate permission={permission} fallback={(child) => renderInert(child, tip)}>
      {children}
    </PermissionGate>
  );
}

function renderInert(children, tip) {
  const child = React.Children.only(children);
  const inert = React.cloneElement(child, {
    disabled: true,             // antd Button/Input/Select/Switch + native controls
    onClick: undefined,         // icons/divs (EditOutlined, .tl-add) ignore `disabled` — drop the handler
    'aria-disabled': true,
    className: `${child.props.className || ''} is-permission-disabled`.trim(),
  });
  // The span both (a) gives antd Tooltip a hover target for a disabled/inert child and
  // (b) insulates the child's className/props from Tooltip's own cloneElement. Absolutely
  // positioned children (the canvas .tl-add `+`) are gated inline instead — a wrapper span
  // collapses to zero-size for them and anchors the tip at the canvas origin.
  return <Tooltip title={tip}><span className="permission-gate">{inert}</span></Tooltip>;
}
